import { Button, Form } from "antd";
import ViagsModalForm from "../../../../components/viags-modal-form/viags-modal-form";
import { PublishPermissionContentEmployeeForm } from "./publish-permission-content-employee";

type FormItemType = {
  employeeData: any[];
};

export const PublishPermissionContentModal = ({ disabled, onConfirm }: { disabled: boolean; onConfirm: any }) => {
  const [form] = Form.useForm();

  const handleClose = () => {};

  const handleFinish = (values: FormItemType) => {
    const { employeeData } = values;
    onConfirm([], employeeData, { reset: handleClose });
    return true;
  };

  return (
    <ViagsModalForm
      trigger={
        <Button disabled={disabled} title={"Phân quyền trên đoạn"} className="mr-2" type="primary">
          Phân quyền trên đoạn
        </Button>
      }
      modalProps={{
        title: "Phân quyền trên đoạn",
        width: "90vw",
        destroyOnClose: true,
        afterClose: handleClose,
      }}
      form={form}
      labelCol={{ span: 6 }}
      size="large"
      layout="horizontal"
      onFinish={handleFinish}
    >
      <PublishPermissionContentEmployeeForm />
    </ViagsModalForm>
  );
};
